/*
  Shared recruitment timeline events (used by Recruitment + EventPopUp)
*/
export const RECRUITMENT_YEAR = 2026;

export const recruitmentEvents = [
  {
    date: "Aug 24",
    title: "Coffee Chats Open!",
    meta: "End 09/14",
    tag: "Pairing Form",
    url: "https://docs.google.com/forms/d/e/1FAIpQLSfpjfJE1VQcAKhAnwLkVOdjtbmhtKjpIYnySE4VRuC5Neqt7g/viewform",
    body: "Coffee chats are a great way to get to know the amazing current members of ENT. Feel free to ask about the organization, entrepreneurship, Cornell, or anything on your mind. These informal conversations can be scheduled using the pairing form link. Note that you can also email ENT members directly for coffee chats from the Members Page."
  },
  {
    date: "Aug 28",
    title: "Future Founders Barbecue",
    meta: "5:00 PM – 7:00 PM | Location: Rawlings Green on North Campus",
    body: "Enjoy some food, play some outdoor sports, and chat with our current ENT members."
  },
  {
    date: "Aug 31",
    title: "Freshman Info Session",
    meta: "6:30 PM – 7:30 PM | Location: RPCC 205",
    body: "ENT information sessions are a great way to learn about the organization. You will hear about the New Member Education process, some fun brotherhood events, current projects, and club culture. Additionally, you will have the opportunity to network to current members at the conclusion of the session. This event is for freshmen only!"
  },
  {
    date: "Sep 1",
    title: "PFC Fair",
    meta: "11:30 AM – 1:00 PM | Location: Willard Straight Hall",
    body: "Learn about all the pre-professional fraternities that Cornell has to offer. Come to our table to say hello!"
  },
  {
    date: "Sep 3",
    title: "Eship Kickoff",
    meta: "4:30 PM – 6:30 PM | Location: eHub Collegetown",
    body: "Get an overview of the vast entrepreneurship opportunities available at Cornell, watch eLab pitches, and meet people passionate about entrepreneurship."
  },
  {
    date: "Sep 5",
    title: "Clubfest",
    meta: "12:00 PM - 1:30 PM | Location: Arts Quad",
    body: "Find the ENT booth at Club Fest and speak to our current members to learn more about what makes the organization special!"
  },
  {
    date: "Sep 9",
    title: "Info Session #1",
    meta: "6:00 PM – 7:00 PM | Location: Warren Hall 151",
    body: "ENT information sessions are a great way to learn about the organization. You will hear about the New Member Education process, some fun brotherhood events, current projects, and club culture. Additionally, you will have the opportunity to network to current members at the conclusion of the session. This event is open to anyone!"
  },
  {
    date: "Sep 10",
    title: "Speed Coffee Chats",
    meta: "5:00 PM – 7:00 PM | Location: Willard Straight Terrace",
    body: "Meet ENT members, ask questions, and learn what ENT is all about!"
  },
  {
    date: "Sep 11",
    title: "Pickleball Tournament",
    meta: "4:00 PM - 6:00 PM | Location TBD",
    body: "Play a friendly game of Pickleball to bond with the current members of ENT. You’ll get to have fun while getting to talk to more of our members."
  },
  {
    date: "Sep 13",
    title: "Virtual Info Session",
    meta: "5:00 PM - 6:00 PM | Location: Zoom",
    tag: "Zoom Link",
    url: "https://cornell.zoom.us/j/96625452323?pwd=f5b1fwZuQM75V4qlmLZMZ5ccIF1c3q.1",
    body: "ENT information sessions are a great way to learn about the organization. You will hear about the New Member Education process, some fun brotherhood events, current projects, and club culture. Additionally, you will have the opportunity to network to current members at the conclusion of the session. This event is open to anyone!"
  }
  /*
  {
    date: "Sep 8",
    title: "Cornell Creators’ Market",
    meta: "12:00 PM – 4:00 PM | Location TBD",
    body: "Visit student vendors from Cornell University selling their handmade goods and services! This is a great way to meet people in the entrepreneurial ecosystem and who knows, perhaps you’ll find a new trinket to take home."
  },
  */
];
